<script setup>
import secondsToHuman from '@/Functions/secondsToHuman.js'
import { Link } from '@inertiajs/vue3'

const props = defineProps({
    label: String,
    totalSeconds: Number,
    percentageProgress: Number,
    playedSeconds: Number,
    remainingSeconds: Number,
    showUnauthenticated: Boolean
})
</script>

<template>
    <div>
        <div class="z-20 border-2 border-[rgba(147,132,241,0.2)] rounded-2xl flex items-center">
            <div class="relative after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:w-px after:h-12 after:bg-[rgba(147,132,241,0.3)] py-5 px-6 flex justify-center items-center">
                <!-- Progress bar -->
                <div class="lg:w-[100px]">
                    <div class="relative w-[53px] h-[53px] rounded-full border-[4px] border-[rgba(32,44,81,1)] mx-auto flex items-center justify-center text-xs font-semibold [text-shadow:2px_2px_10px_rgba(177,125,254,0.8)] text-[rgba(177,125,254,1)] before:absolute before:rounded-full before:-top-[4px] before:-left-[4px] before:-right-[4px] before:-bottom-[4px] before:[mask:radial-gradient(farthest-side,#0000_calc(99%-4px),#000_calc(100%-4px))] before:[background:conic-gradient(rgba(177,125,254,1)_calc(var(--value)*1%),#0000_0)]" :style="`--value: ${percentageProgress};`">
                        {{ percentageProgress }}%
                    </div>
                    <div class="text-sm text-[rgba(169,188,255,1)] mt-2 font-medium text-center">{{ label ?? `Your progress` }}</div>
                </div>
            </div>
            <ul class="py-5 px-6 text-xs space-y-2 leading-tight">
                <li>
                    <span class="text-[rgba(177,125,254,1)]">Total: </span>
                    <span class="text-[rgba(169,188,255,1)] font-semibold">{{ secondsToHuman(totalSeconds) }}</span>
                </li>
                <li>
                    <span class="text-[rgba(177,125,254,1)]">Played: </span>
                    <span class="text-[rgba(169,188,255,1)] font-semibold">{{ secondsToHuman(playedSeconds) }}</span>
                </li>
                <li>
                    <span class="text-[rgba(177,125,254,1)]">Remaining: </span>
                    <span class="text-[rgba(169,188,255,1)] font-semibold">{{ secondsToHuman(remainingSeconds) }}</span>
                </li>
            </ul>
        </div>
        <div class="text-center mt-4 text-sm text-[rgba(169,188,255,1)]" v-if="showUnauthenticated">
            <Link :href="`/auth/register`" :data="{ from: $page.url }" preserve-state class="underline">Join</Link> or <Link :href="`/auth/signin`" class="underline" preserve-state preserve-scroll :data="{ from: $page.url }">sign in</Link> to track your progress
        </div>
    </div>
</template>
